import React , { useEffect } from 'react';
import { insertError } from "../libs/hooksLib"; 

export default function SoundClip (props) {
  
  useEffect(() => {
    const audioEl = document.getElementById("myAudio");
    if(props.play.state) {
      try {audioEl.play();}
      catch(e) { insertError(e);}
    } else {
      try {audioEl.pause();}
      catch(e) { insertError(e);}
    }
  }, [props.play]);
      
  return (
    <div>
      <audio id="myAudio">
        <source src="/soundclip.mp3"></source>
      </audio>
    </div>
  ) 
}